// extracted by mini-css-extract-plugin
export default {"wrap":"Select_wrap__t96P2","select":"Select_select__SoJMj","md":"Select_md__V4qC3","sm":"Select_sm__rSJYh","chevron":"Select_chevron__mfwh8","disabled":"Select_disabled__pR6kx"};